import Alert from 'elements/Alert'
import { styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const StyledAlert = styled(Alert)({
  marginBottom: '24px',
})

const CommercialPropertyProposalAlert = () => {
  const translate = useTranslate()

  return (
    <StyledAlert severity="warning">
      <Typography textVariant="subtitle2" colorHex="#BA622E">
        {translate(`You're working on a commercial project`)}
      </Typography>
      <Typography textVariant="helper1" colorHex="#BA622E">
        {translate(
          'The Sales Machine Swipe Proposal is currently unavailable for commercial use. You can continue using the Classic Proposal for this project.'
        )}
      </Typography>
    </StyledAlert>
  )
}

export default CommercialPropertyProposalAlert
